import React, { FC } from 'react';
import styled from 'styled-components';
import { FileDropZone, Loader, SdiTrash, TextLink } from '@sdir/sds';
import { useIntl } from 'react-intl';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { FileViewer } from './FileViewer';
import { FileSelect } from './FileSelect';
import { Loadable } from '../../../types';
import { VirtualFile } from '../../../types/filegroup';

interface FileGroupProps {
  selectedFileOption: VirtualFile | null;
  selectedFile: Loadable<File> | null;
  availableFiles: VirtualFile[];
  onSelectFile: (file: VirtualFile) => void;
  onDeleteSelectedFile: () => void;
  onNewFilesAdded: (files: File[]) => void;
}

export const FileGroup: FC<FileGroupProps> = ({
  selectedFile,
  availableFiles,
  selectedFileOption,
  onSelectFile,
  onDeleteSelectedFile,
  onNewFilesAdded,
}) => {
  const intl = useIntl();

  return (
    <FileGroupWrapper>
      <div className="filegroup-selected-view">
        {selectedFile ? (
          <>
            {selectedFile.loading && <Loader />}
            {selectedFile.error && <ErrorMessage error={selectedFile.error} />}
            {selectedFile.result && <FileViewer file={selectedFile.result} />}
          </>
        ) : (
          <FileDropZone
            label={intl.formatMessage({ id: 'app.manual.drop.file' })}
            allowedTypes=".png,.jpg,.jpeg,.pdf"
            onFilesSelected={onNewFilesAdded}
            onFilesDrop={onNewFilesAdded}
          />
        )}
      </div>
      <div className="filegroup-controls-view">
        {selectedFile && (
          <div>
            <TextLink
              text={intl.formatMessage({ id: 'general.form.deletedocument' })}
              icon={<SdiTrash size="s" height="1em" />}
              click={onDeleteSelectedFile}
            />
          </div>
        )}
        <FileSelect
          availableFiles={availableFiles}
          selectedFileOption={selectedFileOption}
          onNewFilesAdded={onNewFilesAdded}
          onSelectFile={onSelectFile}
        />
      </div>
    </FileGroupWrapper>
  );
};

const FileGroupWrapper = styled.div`
  display: grid;
  gap: 16px;
  grid-template-rows: auto auto;

  .filegroup-selected-view {
    grid-row: 1;
    overflow-y: auto;
    height: 800px;

    @media screen and (max-width: ${({ theme }) => theme.screen.xLarge}) {
      height: 520px;
    }
  }

  .filegroup-controls-view {
    grid-row: 2;
  }
`;
